import {Injectable, Inject} from 'ng-metadata/core';
import {MappingTablesCache} from '../../mappingTablesCache/mappingTablesCache.service';
import {getVid, getInstitutionCode} from '../../appConfig/appConfigForward';
import {getBackendSystem, getQuickLinkEnabled, isDisplayUnpaywallLinks} from '../../appConfig/appConfigForward';
import {HttpService} from '../../infra/httpRequest/http.service';


const get = require('lodash/get');
const set = require('lodash/set');
const _ = require('lodash');
const isEmpty = require('lodash/isEmpty');
const isEqual = require('lodash/isEqual');

@Injectable()
export class QuickLink {

    private _linksDefinitions: any;
    private vid = getVid();
	private jsonResponseString;
	private _unpaywallLinks;
    private isQuickLinksEnabled;
    private isUnpaywallEnabled;
    private excludeEZproxyValues = ["unpaywall"];
    private _showNoLinksErrorlabel: boolean = true;

    constructor(@Inject('$http') private $http,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
				@Inject('restBaseURLs') private restBaseURLs,
                private mappingTablesCache: MappingTablesCache,
				private httpService : HttpService) {
                    this.isQuickLinksEnabled = this.isQuickLinksEnabledFromConfig();
                    this.isUnpaywallEnabled = this.isUnpaywallEnabledFromConfig();
    }


	get quickLinksEnabled() {
        return this.isQuickLinksEnabled;
    }

    get unpaywallEnabled() {
        return this.isUnpaywallEnabled;
    }

    get unpaywallLinks() {
        return this._unpaywallLinks;
    }
    
    set showNoLinksErrorlabel(value: boolean) {
		this._showNoLinksErrorlabel = value;
	}

	get showNoLinksErrorlabel() {
		return this._showNoLinksErrorlabel;
	}
    
    public getQuickLinksFromPnx(item) {
        let linksToReturn = [];

        if (this.isQuickLinksEnabled) {
            if (get(item, 'pnx.links.linktopdf[0]', false)) {
                linksToReturn.push(this.parseQuickLink(item.pnx.links.linktopdf[0], 'PDF'));
            }

            if (get(item, 'pnx.links.linktohtml[0]', false)) {
                linksToReturn.push(this.parseQuickLink(item.pnx.links.linktohtml[0], 'HTML'));
            }
        }

        return linksToReturn;
    }


    private parseQuickLink(fullQuickLink, elementType) {
        let quickLinkType = this.getSubfieldFromVal(fullQuickLink + '', '$$E');
        let quickSourceType = this.getSubfieldFromVal(fullQuickLink + '', '$$S');
        let quickOA = this.getSubfieldFromVal(fullQuickLink + '', '$$H');
        let institutionBaseURLs = this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.INSTITUTIONS_BASE_URLS, {source1: getInstitutionCode(),source2: 'proxy_prefix'});
        let proxyPrefix = '';
        
        if (!this.excludeEZproxyValues.includes(quickSourceType) && get(institutionBaseURLs,'[0].target')){        //if not unpaywall AND ezproxy is configured
            proxyPrefix = (quickOA == 'free_for_read' && this.isDoNotProxyOpenAccessRecordsEnabled(institutionBaseURLs)) ? '' : get(institutionBaseURLs,'[0].target')       //if the record is OA AND doNotProxy is enabled, use an empty proxy. Otherwise, use the ezproxy from BO
        }

        if (quickLinkType.toUpperCase() !== elementType.toUpperCase()) {
            return ({});
        }
        
        let sourceTypeForLabels 	= "";
        let sourceTypeForLabelsAria = "";
        if(quickSourceType === "unpaywall"){
			sourceTypeForLabels = quickSourceType+".";
		}
		else {
			sourceTypeForLabelsAria = "quicklink.";
		}

        let jsonObject =
            {
                "type": quickLinkType,
                "url": proxyPrefix + this.getSubfieldFromVal(fullQuickLink + '', '$$U'),
                "priority": this.getSubfieldFromVal(fullQuickLink + '', '$$P'),
                "provider": this.getSubfieldFromVal(fullQuickLink + '', '$$G'),
                "oaLink": quickOA,
                "sourceType": quickSourceType,
                "tooltip": 'fulldisplay.' + sourceTypeForLabels + elementType + '.tooltip',
                "label": 'fulldisplay.' + sourceTypeForLabels + elementType,
                "ariaLabel": 'nui.aria.' + sourceTypeForLabelsAria + sourceTypeForLabels + elementType
            };

        return jsonObject;
    }

    public isQuickLinksAvailable(item) {

        let quickLinkAvailableInPnx = get(item, 'pnx.links.linktopdf[0]', false) || get(item, 'pnx.links.linktohtml[0]', false);
        return (quickLinkAvailableInPnx && this.isQuickLinksEnabled);
    }

    public isQuickLinksEnabledFromConfig() {

        if (getBackendSystem() === 'suprima') {
            return getQuickLinkEnabled();
        } 
        return this.mappingTablesCache.findByProperties('View Properties', {
                source1: getVid(),
                source2: 'enable_quicklink_icons',
                target: 'true'
            }).length !== 0;
    }

    public isUnpaywallEnabledFromConfig() {

        if (getBackendSystem() === 'suprima') {
            return isDisplayUnpaywallLinks();
        } 
        return this.mappingTablesCache.findByProperties('View Properties', {
            source1: getVid(),
            source2: 'enable_unpaywall_links',
            target: 'true'
        }).length !== 0;
    }

    public isUnpaywallLinksAvailable(items) {

        if (!this.isUnpaywallEnabled) {
            return false;
        }

        //check if at least one DOI exists
        for (var i = 0; i < items.length; i++) {
            if (get(items[i], 'pnx.addata.doi', false)) {
                return true;
            }
        }
        return false;
    }

    public getSubfieldFromVal(value, subfield) {

        if (this.isSubfieldExist(value, subfield)) {
            let val = value.split(subfield)[1];
            if (val.indexOf('$$')!==-1) {
                val = val.substring(0, val.indexOf('$$'))
            }
            return val;
        } else {
            return value;
        }
    }

    public isSubfieldExist(value, subfield) {
        return value.includes(subfield);
    }


    public updateUnpaywallLinks(items) {

        if (!items || !this.isUnpaywallEnabled) {
            return;
        }

        // parse addata and fetch all DOIs 
        let jsonDois = this.fetchDOIsFromData(items);
        if (!jsonDois || isEmpty(jsonDois)) {
            return;
        }
        let jsonDoisStr = JSON.stringify(jsonDois);
        this.fetchURLsFromUnpaywall(jsonDoisStr, items);

    }

    private fetchDOIsFromData(items) {
        // Prepare DOIs list in json format
        let jsonDois = {};

        for (let i = 0; i < items.length; i++) {
            let item = items[i];
                if (get(item, 'pnx.addata.doi')) {
                    let linktopdf = get(item, 'pnx.links.linktopdf[0]', false);
                let linktohtml = get(item, 'pnx.links.linktohtml[0]', false);
                if (!this.isQuickLinksEnabled || (!linktopdf && !linktohtml)) {
                    let doi = get(item, 'pnx.addata.doi[0]', "");
                    let recordId = get(item, 'pnx.control.recordid[0]', "");
                    if (doi != "" && recordId != "") {
                        jsonDois[doi] = recordId;
                    }
                }
            }
        }
        return jsonDois;
    }
	

    public fetchURLsFromUnpaywall(jsonDoisString, items) {

        // Send GET request to Unpaywall restAPI (server)
        this.httpService.callPostAndParams(this.restBaseURLs.unpaywallURL, "", jsonDoisString)
            .then((data: any) => {

                let linksToReturn = [];
                for (var key in data) {
                    var url = data[key].url;
                    let array = [];
                    if (!(key.startsWith("beacon") || typeof url === 'undefined' || url === null)) {
                        var element = "$$U" + url + "$$EPDF$$P$$G$$H$$Sunpaywall";
                        array.push(this.parseQuickLink(element, 'PDF'));
                        linksToReturn[key] = array;

                        for (var i = 0; i < items.length; i++) {
                            var item = items[i];
                            if (get(item, 'pnx.control.recordid[0]') == key) {
                                set(item, 'pnx.links.linktopdf[0]', "$$U" + url + "$$EPDF$$P$$G$$H$$Sunpaywall");
                            }
                        }
                    }
                }
                this._unpaywallLinks = linksToReturn;
            });
    }

    private isDoNotProxyOpenAccessRecordsEnabled(mtLine) {
        return mtLine && mtLine.length > 0 && mtLine[0].source4 !== undefined && isEqual(mtLine[0].source4, 'Y');
    }

    }


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/quickLink/quickLink.service.ts